import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100",
    style: { "z-index": "9999" }
};
const _hoisted_2 = {
    key: 1,
    class: "row"
};
const _hoisted_3 = { class: "col-lg-5 col-xl-4" };
const _hoisted_4 = { class: "col-lg-7 col-xl-8" };
const _hoisted_5 = { class: "leads-details-tabs" };
const _hoisted_6 = {
    class: "nav nav-tabs border-0 mb-25",
    id: "myTab",
    role: "tablist"
};
const _hoisted_7 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_8 = {
    class: "nav-link fs-md-15 fs-lg-16 fw-medium border-0 rounded-0 d-block text-center w-100 active",
    id: "tasks-tab",
    "data-bs-toggle": "tab",
    "data-bs-target": "#tasks-tab-pane",
    type: "button",
    role: "tab",
    "aria-controls": "tasks-tab-pane",
    "aria-selected": "true"
};
const _hoisted_9 = {
    class: "tab-content",
    id: "myTabContent"
};
const _hoisted_10 = {
    class: "tab-pane fade show active",
    id: "tasks-tab-pane",
    role: "tabpanel",
    tabindex: "0"
};
const _hoisted_11 = {
    key: 0,
    class: "card mb-3"
};
const _hoisted_12 = { class: "card-header bg-warning text-white d-flex justify-content-between align-items-center" };
const _hoisted_13 = {
    key: 0,
    class: "card-body p-3"
};
const _hoisted_14 = { class: "row mb-2" };
const _hoisted_15 = { class: "col-sm-4 fw-bold" };
const _hoisted_16 = { class: "col-sm-8" };
const _hoisted_17 = { class: "row mb-2" };
const _hoisted_18 = { class: "col-sm-4 fw-bold" };
const _hoisted_19 = { class: "col-sm-8" };
const _hoisted_20 = { class: "row mb-2" };
const _hoisted_21 = { class: "col-sm-4 fw-bold" };
const _hoisted_22 = { class: "col-sm-8" };
const _hoisted_23 = { class: "row mb-2" };
const _hoisted_24 = { class: "col-sm-4 fw-bold" };
const _hoisted_25 = { class: "col-sm-8" };
const _hoisted_26 = { class: "row mb-2" };
const _hoisted_27 = { class: "col-sm-4 fw-bold" };
const _hoisted_28 = { class: "col-sm-8" };
const _hoisted_29 = { class: "d-flex justify-content-center mt-3" };
const _hoisted_30 = ["disabled"];
const _hoisted_31 = { class: "align-self-center" };
const _hoisted_32 = ["disabled"];
const _hoisted_33 = {
    key: 1,
    class: "card-body p-3"
};
const _hoisted_34 = { class: "mb-1" };
const _hoisted_35 = {
    key: 1,
    class: "card mb-3"
};
const _hoisted_36 = { class: "card-header bg-success text-white" };
const _hoisted_37 = { class: "card-body p-3" };
const _hoisted_38 = { class: "row mb-2" };
const _hoisted_39 = { class: "col-sm-4 fw-bold" };
const _hoisted_40 = { class: "col-sm-4" };
const _hoisted_41 = { class: "col-sm-4" };
const _hoisted_42 = ["placeholder"];
const _hoisted_43 = { class: "row mb-2" };
const _hoisted_44 = { class: "col-sm-4 fw-bold" };
const _hoisted_45 = { class: "col-sm-8" };
const _hoisted_46 = { class: "row mb-2" };
const _hoisted_47 = { class: "col-sm-4 fw-bold" };
const _hoisted_48 = { class: "col-sm-8" };
const _hoisted_49 = { class: "row mb-2" };
const _hoisted_50 = { class: "col-sm-4 fw-bold" };
const _hoisted_51 = { class: "col-sm-8" };
const _hoisted_52 = {
    key: 0,
    class: "row mb-2"
};
const _hoisted_53 = { class: "col-sm-4 fw-bold" };
const _hoisted_54 = { class: "col-sm-8 text-success fw-bold" };
const _hoisted_55 = {
    key: 1,
    class: "border-top mt-3 pt-3"
};
const _hoisted_56 = { class: "fw-bold mb-3" };
const _hoisted_57 = { class: "row justify-content-center" };
const _hoisted_58 = { class: "col-md-10 col-lg-8" };
const _hoisted_59 = {
    key: 2,
    class: "card mb-3"
};
const _hoisted_60 = { class: "card-header bg-danger text-white" };
const _hoisted_61 = {
    key: 0,
    class: "card-body p-3"
};
const _hoisted_62 = { class: "mb-1" };
const _hoisted_63 = {
    key: 1,
    class: "card-body p-3"
};
const _hoisted_64 = {
    key: 0,
    class: "mb-1"
};
const _hoisted_65 = { class: "mb-1 badge text-outline-success" };
const _hoisted_66 = { key: 1 };
const _hoisted_67 = { key: 2 };
const _hoisted_68 = { class: "mb-1 badge text-outline-warning" };
const _hoisted_69 = { class: "mb-1 text-muted" };
const _hoisted_70 = { class: "text-success" };
const _hoisted_71 = ["title"];
const _hoisted_72 = { class: "text-warning" };
const _hoisted_73 = { key: 0 };
const _hoisted_74 = {
    key: 1,
    class: "text-warning"
};
const _hoisted_75 = { key: 2 };
const _hoisted_76 = { class: "fw-bold" };
const _hoisted_77 = ["onClick"];
const _hoisted_78 = {
    key: 0,
    class: "d-flex justify-content-center mt-3"
};
const _hoisted_79 = ["disabled"];
const _hoisted_80 = { class: "align-self-center" };
const _hoisted_81 = ["disabled"];
const _hoisted_82 = {
    key: 2,
    class: "card-body p-3"
};
const _hoisted_83 = { class: "mb-1" };
const _hoisted_84 = {
    key: 3,
    class: "card mb-3"
};
const _hoisted_85 = { class: "card-header bg-danger text-white" };
const _hoisted_86 = {
    key: 0,
    class: "card-body p-3"
};
const _hoisted_87 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_88 = { class: "d-flex align-items-center" };
const _hoisted_89 = {
    for: "itemsPerTablePage",
    class: "me-2 mb-0"
};
const _hoisted_90 = { class: "table-responsive" };
const _hoisted_91 = { class: "table table-striped table-hover" };
const _hoisted_92 = ["href"];
const _hoisted_93 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_94 = {
    key: 0,
    class: "d-flex justify-content-center mt-3"
};
const _hoisted_95 = ["disabled"];
const _hoisted_96 = { class: "align-self-center" };
const _hoisted_97 = ["disabled"];
const _hoisted_98 = {
    key: 1,
    class: "card-body p-3"
};
const _hoisted_99 = { class: "mb-1" };
const _hoisted_100 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_101 = { class: "modal-content" };
const _hoisted_102 = { class: "modal-header" };
const _hoisted_103 = {
    class: "modal-title",
    id: "addAddressModalLabel"
};
const _hoisted_104 = { class: "modal-body" };
const _hoisted_105 = { class: "mb-3" };
const _hoisted_106 = { class: "form-label" };
const _hoisted_107 = ["placeholder"];
const _hoisted_108 = { class: "mb-3" };
const _hoisted_109 = { class: "form-label" };
const _hoisted_110 = ["placeholder"];
const _hoisted_111 = { class: "mb-3" };
const _hoisted_112 = { class: "form-label" };
const _hoisted_113 = ["placeholder"];
const _hoisted_114 = { class: "mb-3" };
const _hoisted_115 = { class: "form-label" };
const _hoisted_116 = ["placeholder"];
const _hoisted_117 = { class: "mb-3" };
const _hoisted_118 = { class: "form-label" };
const _hoisted_119 = ["placeholder"];
const _hoisted_120 = { class: "d-flex justify-content-end gap-2" };
const _hoisted_121 = ["disabled"];
const _hoisted_122 = { key: 0 };
const _hoisted_123 = { key: 1 };
const _hoisted_124 = {
    key: 3,
    class: "card mb-25 border-0 rounded-0 bg-white add-user-card"
};
const _hoisted_125 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_126 = { class: "row" };
const _hoisted_127 = { class: "col-md-6" };
const _hoisted_128 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_129 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_130 = { class: "col-md-6" };
const _hoisted_131 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_132 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_133 = ["placeholder"];
const _hoisted_134 = { class: "col-md-6" };
const _hoisted_135 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_136 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_137 = ["placeholder"];
const _hoisted_138 = { class: "col-md-6" };
const _hoisted_139 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_140 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_141 = ["placeholder"];
const _hoisted_142 = { class: "col-md-6" };
const _hoisted_143 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_144 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_145 = ["placeholder"];
const _hoisted_146 = { class: "col-md-6" };
const _hoisted_147 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_148 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_149 = ["placeholder"];
const _hoisted_150 = { class: "col-md-6" };
const _hoisted_151 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_152 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_153 = ["placeholder"];
const _hoisted_154 = { class: "col-md-6" };
const _hoisted_155 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_156 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_157 = ["placeholder"];
const _hoisted_158 = { class: "col-md-12" };
const _hoisted_159 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_160 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_161 = ["placeholder"];
const _hoisted_162 = { class: "col-md-12" };
const _hoisted_163 = { class: "d-flex justify-content-end gap-2" };
const _hoisted_164 = ["disabled"];
const _hoisted_165 = { key: 0 };
const _hoisted_166 = { key: 1 };
const _hoisted_167 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_168 = { class: "modal-content" };
const _hoisted_169 = { class: "modal-header" };
const _hoisted_170 = { class: "modal-body" };
const _hoisted_171 = { class: "text-muted small mb-3" };
const _hoisted_172 = { class: "form-group mb-3" };
const _hoisted_173 = ["value"];
const _hoisted_174 = {
    key: 0,
    class: "alert alert-success mt-3 text-center"
};
const _hoisted_175 = { class: "mb-0 letter-spacing fw-bold" };
const _hoisted_176 = { class: "modal-footer" };
const _hoisted_177 = ["disabled"];
const _hoisted_178 = ["disabled"];
const _hoisted_179 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_180 = {
    key: 4,
    class: "modal-backdrop fade show",
    style: { "z-index": "10000" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_LeadsInformation = _resolveComponent("LeadsInformation");
    const _component_apexchart = _resolveComponent("apexchart");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_LoaderComponent)
            ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.categorieResponse)
                        ? (_openBlock(), _createBlock(_component_LeadsInformation, {
                            key: 0,
                            lead: _ctx.categorieResponse,
                            onGenerateCoupon: _ctx.openCouponModal
                        }, null, 8, ["lead", "onGenerateCoupon"]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("ul", _hoisted_6, [
                            _createElementVNode("li", _hoisted_7, [
                                _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.$t('customer.customerSpecification')), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                (_ctx.categorieResponse)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('customer.registeredAddressesList')), 1),
                                            (_ctx.action === 'edit')
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "btn btn-sm btn-light",
                                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.showAddAddressForm = true))
                                                }, [
                                                    _cache[44] || (_cache[44] = _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1)),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('customer.addAddress')), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (_ctx.categorieResponse.listeAdresses &&
                                            _ctx.categorieResponse.listeAdresses.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedAdresses, (adresse) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: adresse.id,
                                                        class: "mb-3 border-bottom pb-2"
                                                    }, [
                                                        _createElementVNode("div", _hoisted_14, [
                                                            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('order.postalCode')) + " :", 1),
                                                            _createElementVNode("div", _hoisted_16, _toDisplayString(adresse.postal_code ?? "-"), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_17, [
                                                            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('order.locality')) + " :", 1),
                                                            _createElementVNode("div", _hoisted_19, _toDisplayString(adresse.city ?? "-"), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_20, [
                                                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('order.street')) + " :", 1),
                                                            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.getStreetWithoutNumber(adresse)), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_23, [
                                                            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('order.number')) + ":", 1),
                                                            _createElementVNode("div", _hoisted_25, _toDisplayString(adresse.numeroRue ?? "-"), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_26, [
                                                            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('customer.remark')) + ":", 1),
                                                            _createElementVNode("div", _hoisted_28, _toDisplayString(adresse.additionalAddress ?? "-"), 1)
                                                        ])
                                                    ]));
                                                }), 128)),
                                                _createElementVNode("div", _hoisted_29, [
                                                    _createElementVNode("button", {
                                                        class: "btn btn-sm btn-outline-secondary me-2",
                                                        disabled: _ctx.currentAdressePage === 1,
                                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.goToAdressePage(_ctx.currentAdressePage - 1)))
                                                    }, _toDisplayString(_ctx.$t('common.previous')), 9, _hoisted_30),
                                                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('common.page')) + " " + _toDisplayString(_ctx.currentAdressePage) + " / " + _toDisplayString(_ctx.totalAdressesPages), 1),
                                                    _createElementVNode("button", {
                                                        class: "btn btn-sm btn-outline-secondary ms-2",
                                                        disabled: _ctx.currentAdressePage === _ctx.totalAdressesPages,
                                                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.goToAdressePage(_ctx.currentAdressePage + 1)))
                                                    }, _toDisplayString(_ctx.$t('common.next')), 9, _hoisted_32)
                                                ])
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                _createElementVNode("h5", _hoisted_34, _toDisplayString(_ctx.$t('customer.noRegisteredAddresses')), 1)
                                            ]))
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.categorieResponse)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('customer.orderAnalysis')), 1),
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("div", _hoisted_38, [
                                                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('customer.specificAttentionPoints')) + " : ", 1),
                                                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.formatCommentaire(_ctx.categorieResponse.linger ?? null)), 1),
                                                _createElementVNode("div", _hoisted_41, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control form-control-sm",
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.lingerValue) = $event)),
                                                        placeholder: _ctx.$t('customer.enterAttentionPoints'),
                                                        onKeyup: _cache[4] || (_cache[4] = _withKeys(
                                                        //@ts-ignore
                                                        (...args) => (_ctx.saveLinger && _ctx.saveLinger(...args)), ["enter"]))
                                                    }, null, 40, _hoisted_42), [
                                                        [_vModelText, _ctx.lingerValue]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_43, [
                                                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('customer.orderTypesHistory')) + " : ", 1),
                                                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.formatTypeCommande(_ctx.getOrderTypeStats())), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_46, [
                                                _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('customer.cutleryRequestDuringOrders')) + ": ", 1),
                                                _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.formatDemandeCouverts(_ctx.categorieResponse.dernierNombreCouverts ?? null)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_49, [
                                                _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('customer.clientPaymentHabits')) + ": ", 1),
                                                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.formatMethodePaiement(_ctx.categorieResponse.methodePaiementFrequente ?? null)), 1)
                                            ]),
                                            (_ctx.categorieResponse.averageBasket)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                    _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('customer.averageBasket') || 'Panier Moyen') + ": ", 1),
                                                    _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.categorieResponse.averageBasket) + " CHF ", 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_ctx.categorieResponse.platformStats && _ctx.categorieResponse.platformStats.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                    _createElementVNode("h6", _hoisted_56, _toDisplayString(_ctx.$t('customer.orderChannelsBreakdown') || 'Répartition des canaux de commande'), 1),
                                                    _createElementVNode("div", _hoisted_57, [
                                                        _createElementVNode("div", _hoisted_58, [
                                                            _createVNode(_component_apexchart, {
                                                                type: "donut",
                                                                height: "300",
                                                                options: _ctx.platformChartOptions,
                                                                series: _ctx.platformChartSeries
                                                            }, null, 8, ["options", "series"])
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.categorieResponse)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                        _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t('customer.orderHistory')), 1),
                                        (_ctx.categorieResponse.nombreCommandes &&
                                            _ctx.categorieResponse.nombreCommandes > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                _createElementVNode("p", _hoisted_62, [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('customer.totalOrdersNumber')) + " : ", 1),
                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.categorieResponse.nombreCommandes), 1)
                                                ])
                                            ]))
                                            : (_ctx.categorieResponse.orders &&
                                                _ctx.categorieResponse.orders.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedOrders, (commande) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: commande.id,
                                                            class: "mb-3 border-bottom pb-2"
                                                        }, [
                                                            (_ctx.getOrderTypeParType(_ctx.listeOrderType, commande.order_type)
                                                                .length > 0)
                                                                ? (_openBlock(), _createElementBlock("h5", _hoisted_64, _toDisplayString(_ctx.getOrderTypeParType(_ctx.listeOrderType, commande.order_type)[0].libelle), 1))
                                                                : _createCommentVNode("", true),
                                                            _createElementVNode("h2", _hoisted_65, _toDisplayString(commande.DeliveryPreference != "immediat"
                                                                ? _ctx.$t('order.preOrder')
                                                                : _ctx.$t('order.rightAway')), 1),
                                                            (commande.DeliveryPreference !== 'immediat')
                                                                ? (_openBlock(), _createElementBlock("br", _hoisted_66))
                                                                : _createCommentVNode("", true),
                                                            (commande.DeliveryPreference !== 'immediat')
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.convertDateCreate(commande.timeOrder)), 1))
                                                                : _createCommentVNode("", true),
                                                            _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
                                                            _createElementVNode("h2", _hoisted_68, _toDisplayString((commande.restaurantID.name.toLowerCase().includes('morges') ? 'VBM' : 'VBP') + commande.nif), 1),
                                                            _createElementVNode("p", _hoisted_69, [
                                                                _createElementVNode("span", _hoisted_70, [
                                                                    _createTextVNode(" (" + _toDisplayString(commande.orderItems.length) + ") " + _toDisplayString(_ctx.$t('order.products')), 1),
                                                                    _createElementVNode("span", {
                                                                        class: "text-primary",
                                                                        "data-bs-toggle": "tooltip",
                                                                        "data-bs-placement": "top",
                                                                        title: _ctx.getProduitsTooltip(commande.orderItems)
                                                                    }, " (" + _toDisplayString(_ctx.$t('common.view')) + ") ", 9, _hoisted_71)
                                                                ]),
                                                                _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.status')) + " : ", 1),
                                                                _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.fetchStatusOrderFr(commande.status)), 1),
                                                                (_ctx.getMethodePaiementParType(_ctx.listeMethode, commande.paymentID.paymentMethod).length > 0)
                                                                    ? (_openBlock(), _createElementBlock("br", _hoisted_73))
                                                                    : _createCommentVNode("", true),
                                                                (_ctx.getMethodePaiementParType(_ctx.listeMethode, commande.paymentID.paymentMethod).length > 0)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(_ctx.getMethodePaiementParType(_ctx.listeMethode, commande.paymentID.paymentMethod)[0].libelle), 1))
                                                                    : _createCommentVNode("", true),
                                                                (_ctx.getMethodePaiementParType(_ctx.listeMethode, commande.paymentID.paymentMethod).length > 0)
                                                                    ? (_openBlock(), _createElementBlock("br", _hoisted_75))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _createElementVNode("p", _hoisted_76, _toDisplayString(_ctx.$t('order.netTotal')) + " : " + _toDisplayString(commande.total_price) + " CHF ", 1),
                                                            _createElementVNode("button", {
                                                                class: "btn btn-sm btn-outline-secondary me-2",
                                                                onClick: ($event) => (_ctx.selectionOrder(commande))
                                                            }, _toDisplayString(_ctx.$t('order.viewDetails')), 9, _hoisted_77)
                                                        ]));
                                                    }), 128)),
                                                    (_ctx.totalPages > 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                                            _createElementVNode("button", {
                                                                class: "btn btn-sm btn-outline-secondary me-2",
                                                                disabled: _ctx.currentPage === 1,
                                                                onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.goToPage(_ctx.currentPage - 1)))
                                                            }, _toDisplayString(_ctx.$t('common.previous')), 9, _hoisted_79),
                                                            _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.$t('common.page')) + " " + _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1),
                                                            _createElementVNode("button", {
                                                                class: "btn btn-sm btn-outline-secondary ms-2",
                                                                disabled: _ctx.currentPage === _ctx.totalPages,
                                                                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.goToPage(_ctx.currentPage + 1)))
                                                            }, _toDisplayString(_ctx.$t('common.next')), 9, _hoisted_81)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                    _createElementVNode("p", _hoisted_83, _toDisplayString(_ctx.$t('order.noOrders')), 1)
                                                ]))
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.categorieResponse)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                        _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.$t('customer.orderHistoryTable')), 1),
                                        (_ctx.categorieResponse.orders &&
                                            _ctx.categorieResponse.orders.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                                _createElementVNode("div", _hoisted_87, [
                                                    _createElementVNode("div", _hoisted_88, [
                                                        _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.$t('lists.show')) + " :", 1),
                                                        _withDirectives(_createElementVNode("select", {
                                                            id: "itemsPerTablePage",
                                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.itemsPerTablePage) = $event)),
                                                            onChange: _cache[8] || (_cache[8] = ($event) => (_ctx.goToTablePage(1))),
                                                            class: "form-select form-select-sm",
                                                            style: { "width": "auto", "padding-right": "2rem" }
                                                        }, [...(_cache[47] || (_cache[47] = [
                                                                _createElementVNode("option", { value: 5 }, "5", -1),
                                                                _createElementVNode("option", { value: 10 }, "10", -1)
                                                            ]))], 544), [
                                                            [_vModelSelect, _ctx.itemsPerTablePage]
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_90, [
                                                    _createElementVNode("table", _hoisted_91, [
                                                        _createElementVNode("thead", null, [
                                                            _createElementVNode("tr", null, [
                                                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('order.transactionReference')), 1),
                                                                _createElementVNode("th", null, _toDisplayString(_ctx.$t('order.pdf')), 1)
                                                            ])
                                                        ]),
                                                        _createElementVNode("tbody", null, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedTableOrders, (commande) => {
                                                                return (_openBlock(), _createElementBlock("tr", {
                                                                    key: commande.id
                                                                }, [
                                                                    _createElementVNode("td", null, _toDisplayString(commande.transactionReference || "-"), 1),
                                                                    _createElementVNode("td", null, [
                                                                        (_ctx.getPdfUrl(commande))
                                                                            ? (_openBlock(), _createElementBlock("a", {
                                                                                key: 0,
                                                                                href: _ctx.getPdfUrl(commande),
                                                                                target: "_blank",
                                                                                class: "btn btn-sm btn-outline-primary"
                                                                            }, _toDisplayString(_ctx.$t('order.viewPdf')), 9, _hoisted_92))
                                                                            : (_openBlock(), _createElementBlock("span", _hoisted_93, "-"))
                                                                    ])
                                                                ]));
                                                            }), 128))
                                                        ])
                                                    ])
                                                ]),
                                                (_ctx.totalTablePages > 1)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                                        _createElementVNode("button", {
                                                            class: "btn btn-sm btn-outline-secondary me-2",
                                                            disabled: _ctx.currentTablePage === 1,
                                                            onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.goToTablePage(_ctx.currentTablePage - 1)))
                                                        }, _toDisplayString(_ctx.$t('common.previous')), 9, _hoisted_95),
                                                        _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.$t('common.page')) + " " + _toDisplayString(_ctx.currentTablePage) + " / " + _toDisplayString(_ctx.totalTablePages), 1),
                                                        _createElementVNode("button", {
                                                            class: "btn btn-sm btn-outline-secondary ms-2",
                                                            disabled: _ctx.currentTablePage === _ctx.totalTablePages,
                                                            onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.goToTablePage(_ctx.currentTablePage + 1)))
                                                        }, _toDisplayString(_ctx.$t('common.next')), 9, _hoisted_97)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                                _createElementVNode("p", _hoisted_99, _toDisplayString(_ctx.$t('order.noOrdersAvailable')), 1)
                                            ]))
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ])
            ])),
        _createElementVNode("div", {
            class: _normalizeClass(["modal fade", { show: _ctx.showAddAddressForm }]),
            id: "addAddressModal",
            tabindex: "-1",
            "aria-labelledby": "addAddressModalLabel",
            "aria-hidden": "true",
            style: _normalizeStyle({ display: _ctx.showAddAddressForm ? 'block' : 'none' })
        }, [
            _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("h5", _hoisted_103, _toDisplayString(_ctx.$t('customer.addAddress')), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            onClick: _cache[11] || (_cache[11] =
                                //@ts-ignore
                                (...args) => (_ctx.closeAddAddressForm && _ctx.closeAddAddressForm(...args))),
                            "aria-label": "Close"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("form", {
                            onSubmit: _cache[18] || (_cache[18] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.handleCreateAddress && _ctx.handleCreateAddress(...args)), ["prevent"]))
                        }, [
                            _createElementVNode("div", _hoisted_105, [
                                _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.$t('order.street')) + " *", 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.newAddress.street) = $event)),
                                    required: "",
                                    placeholder: _ctx.$t('order.street')
                                }, null, 8, _hoisted_107), [
                                    [_vModelText, _ctx.newAddress.street]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_108, [
                                _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.$t('pos.streetNumber')), 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.newAddress.numeroLocalite) = $event)),
                                    placeholder: _ctx.$t('pos.streetNumber')
                                }, null, 8, _hoisted_110), [
                                    [_vModelText, _ctx.newAddress.numeroLocalite]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_111, [
                                _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.$t('order.locality')) + " *", 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.newAddress.locality) = $event)),
                                    required: "",
                                    placeholder: _ctx.$t('order.locality')
                                }, null, 8, _hoisted_113), [
                                    [_vModelText, _ctx.newAddress.locality]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t('order.postalCode')) + " *", 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.newAddress.codePostal) = $event)),
                                    required: "",
                                    placeholder: _ctx.$t('order.postalCode')
                                }, null, 8, _hoisted_116), [
                                    [_vModelText, _ctx.newAddress.codePostal]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_117, [
                                _createElementVNode("label", _hoisted_118, _toDisplayString(_ctx.$t('forms.additionalAddress') || 'Informations complémentaires'), 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.newAddress.additionalAddress) = $event)),
                                    placeholder: _ctx.$t('forms.additionalAddress') || 'Informations complémentaires'
                                }, null, 8, _hoisted_119), [
                                    [_vModelText, _ctx.newAddress.additionalAddress]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_120, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: _cache[17] || (_cache[17] =
                                        //@ts-ignore
                                        (...args) => (_ctx.closeAddAddressForm && _ctx.closeAddAddressForm(...args)))
                                }, _toDisplayString(_ctx.$t('common.cancel')), 1),
                                _createElementVNode("button", {
                                    type: "submit",
                                    class: "btn btn-primary",
                                    disabled: _ctx.isSavingAddress
                                }, [
                                    (_ctx.isSavingAddress)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_122, _toDisplayString(_ctx.$t('common.saving')) + "...", 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_123, _toDisplayString(_ctx.$t('common.save')), 1))
                                ], 8, _hoisted_121)
                            ])
                        ], 32)
                    ])
                ])
            ])
        ], 6),
        (_ctx.showAddAddressForm)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "modal-backdrop fade show",
                onClick: _cache[19] || (_cache[19] =
                    //@ts-ignore
                    (...args) => (_ctx.closeAddAddressForm && _ctx.closeAddAddressForm(...args)))
            }))
            : _createCommentVNode("", true),
        (_ctx.action === 'edit')
            ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("form", {
                        onSubmit: _cache[39] || (_cache[39] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
                    }, [
                        _createElementVNode("div", _hoisted_126, [
                            _createElementVNode("div", _hoisted_127, [
                                _createElementVNode("div", _hoisted_128, [
                                    _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.$t('forms.civility')) + " * ", 1),
                                    _withDirectives(_createElementVNode("select", {
                                        class: "form-control shadow-none rounded-0 text-black",
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.categorieData.civilite) = $event)),
                                        onChange: _cache[21] || (_cache[21] = (event) => _ctx.handleInput(event, 'civilite')),
                                        required: ""
                                    }, [...(_cache[48] || (_cache[48] = [
                                            _createElementVNode("option", { value: "" }, "-- " + _toDisplayString('Sélectionner') + " --", -1),
                                            _createElementVNode("option", { value: "monsieur" }, "Monsieur", -1),
                                            _createElementVNode("option", { value: "madame" }, "Madame", -1)
                                        ]))], 544), [
                                        [_vModelSelect, _ctx.categorieData.civilite]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_130, [
                                _createElementVNode("div", _hoisted_131, [
                                    _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.$t('forms.firstName')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.categorieData.firstName) }]),
                                        placeholder: _ctx.$t('forms.firstName'),
                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.categorieData.firstName) = $event)),
                                        onChange: _cache[23] || (_cache[23] = (event) => _ctx.handleInput(event, 'firstName')),
                                        required: ""
                                    }, null, 42, _hoisted_133), [
                                        [_vModelText, _ctx.categorieData.firstName]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_134, [
                                _createElementVNode("div", _hoisted_135, [
                                    _createElementVNode("label", _hoisted_136, _toDisplayString(_ctx.$t('forms.lastName')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.categorieData.lastName) }]),
                                        placeholder: _ctx.$t('forms.lastName'),
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.categorieData.lastName) = $event)),
                                        onChange: _cache[25] || (_cache[25] = (event) => _ctx.handleInput(event, 'lastName')),
                                        required: ""
                                    }, null, 42, _hoisted_137), [
                                        [_vModelText, _ctx.categorieData.lastName]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_138, [
                                _createElementVNode("div", _hoisted_139, [
                                    _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.$t('forms.email')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "email",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.categorieData.email) }]),
                                        placeholder: _ctx.$t('forms.email'),
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.categorieData.email) = $event)),
                                        onChange: _cache[27] || (_cache[27] = (event) => _ctx.handleInput(event, 'email')),
                                        required: ""
                                    }, null, 42, _hoisted_141), [
                                        [_vModelText, _ctx.categorieData.email]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_142, [
                                _createElementVNode("div", _hoisted_143, [
                                    _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.$t('forms.phone')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.categorieData.phoneNumber) }]),
                                        placeholder: _ctx.$t('forms.phone'),
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_ctx.categorieData.phoneNumber) = $event)),
                                        onChange: _cache[29] || (_cache[29] = (event) => _ctx.handleInput(event, 'phoneNumber')),
                                        required: ""
                                    }, null, 42, _hoisted_145), [
                                        [_vModelText, _ctx.categorieData.phoneNumber]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_146, [
                                _createElementVNode("div", _hoisted_147, [
                                    _createElementVNode("label", _hoisted_148, _toDisplayString(_ctx.$t('order.street')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.categorieData.address) }]),
                                        placeholder: _ctx.$t('order.street'),
                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((_ctx.categorieData.address) = $event)),
                                        onChange: _cache[31] || (_cache[31] = (event) => _ctx.handleInput(event, 'address')),
                                        required: ""
                                    }, null, 42, _hoisted_149), [
                                        [_vModelText, _ctx.categorieData.address]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_150, [
                                _createElementVNode("div", _hoisted_151, [
                                    _createElementVNode("label", _hoisted_152, _toDisplayString(_ctx.$t('pos.streetNumber')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.categorieData.numeroRue) }]),
                                        placeholder: _ctx.$t('pos.streetNumber'),
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => ((_ctx.categorieData.numeroRue) = $event)),
                                        onChange: _cache[33] || (_cache[33] = (event) => _ctx.handleInput(event, 'numeroRue')),
                                        required: ""
                                    }, null, 42, _hoisted_153), [
                                        [_vModelText, _ctx.categorieData.numeroRue]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_154, [
                                _createElementVNode("div", _hoisted_155, [
                                    _createElementVNode("label", _hoisted_156, _toDisplayString(_ctx.$t('order.locality')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.categorieData.city) }]),
                                        placeholder: _ctx.$t('order.locality'),
                                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((_ctx.categorieData.city) = $event)),
                                        onChange: _cache[35] || (_cache[35] = (event) => _ctx.handleInput(event, 'city')),
                                        required: ""
                                    }, null, 42, _hoisted_157), [
                                        [_vModelText, _ctx.categorieData.city]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_158, [
                                _createElementVNode("div", _hoisted_159, [
                                    _createElementVNode("label", _hoisted_160, _toDisplayString(_ctx.$t('order.postalCode')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.categorieData.codePostal) }]),
                                        placeholder: _ctx.$t('order.postalCode'),
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((_ctx.categorieData.codePostal) = $event)),
                                        onChange: _cache[37] || (_cache[37] = (event) => _ctx.handleInput(event, 'codePostal')),
                                        required: ""
                                    }, null, 42, _hoisted_161), [
                                        [_vModelText, _ctx.categorieData.codePostal]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_162, [
                                _createElementVNode("div", _hoisted_163, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-secondary",
                                        onClick: _cache[38] || (_cache[38] =
                                            //@ts-ignore
                                            (...args) => (_ctx.goBack && _ctx.goBack(...args)))
                                    }, _toDisplayString(_ctx.$t('common.cancel')), 1),
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn btn-primary",
                                        disabled: !_ctx.isFormValid || _ctx.isSaving
                                    }, [
                                        (_ctx.isSaving)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_165, _toDisplayString(_ctx.$t('common.saving')) + "...", 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_166, _toDisplayString(_ctx.$t('common.save')), 1))
                                    ], 8, _hoisted_164)
                                ])
                            ])
                        ])
                    ], 32)
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", {
            class: _normalizeClass(["modal fade", { show: _ctx.showCouponModal }]),
            id: "manualCouponModal",
            tabindex: "-1",
            "aria-hidden": "true",
            style: _normalizeStyle({ display: _ctx.showCouponModal ? 'block' : 'none', zIndex: 10001 })
        }, [
            _createElementVNode("div", _hoisted_167, [
                _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                        _cache[49] || (_cache[49] = _createElementVNode("h5", { class: "modal-title" }, "Générer un Coupon Manuel", -1)),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            onClick: _cache[40] || (_cache[40] = ($event) => (_ctx.showCouponModal = false))
                        })
                    ]),
                    _createElementVNode("div", _hoisted_170, [
                        _createElementVNode("p", _hoisted_171, [
                            _cache[50] || (_cache[50] = _createTextVNode(" Choisissez un modèle de coupon à générer pour ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.categorieResponse?.firstName) + " " + _toDisplayString(_ctx.categorieResponse?.lastName), 1),
                            _cache[51] || (_cache[51] = _createTextVNode(". ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_172, [
                            _cache[53] || (_cache[53] = _createElementVNode("label", { class: "form-label" }, "Modèle de coupon *", -1)),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((_ctx.selectedTemplateId) = $event)),
                                class: "form-select shadow-none"
                            }, [
                                _cache[52] || (_cache[52] = _createElementVNode("option", { value: "" }, "-- Sélectionner un modèle --", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couponTemplates, (tpl) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: tpl.id,
                                        value: tpl.id
                                    }, _toDisplayString(tpl.code) + " - (" + _toDisplayString(tpl.type === 'fixed' ? tpl.value + ' CHF' : tpl.value + '%') + ") ", 9, _hoisted_173));
                                }), 128))
                            ], 512), [
                                [_vModelSelect, _ctx.selectedTemplateId]
                            ])
                        ]),
                        (_ctx.generatedCouponCode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                _cache[54] || (_cache[54] = _createElementVNode("p", { class: "mb-2" }, "Coupon généré avec succès !", -1)),
                                _createElementVNode("h4", _hoisted_175, _toDisplayString(_ctx.generatedCouponCode), 1),
                                _cache[55] || (_cache[55] = _createElementVNode("small", { class: "text-muted" }, "Communiquez ce code au client.", -1))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_176, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[42] || (_cache[42] = ($event) => (_ctx.showCouponModal = false)),
                            disabled: _ctx.isGeneratingCoupon
                        }, " Fermer ", 8, _hoisted_177),
                        (!_ctx.generatedCouponCode)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-primary",
                                onClick: _cache[43] || (_cache[43] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleGenerateCoupon && _ctx.handleGenerateCoupon(...args))),
                                disabled: !_ctx.selectedTemplateId || _ctx.isGeneratingCoupon
                            }, [
                                (_ctx.isGeneratingCoupon)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_179))
                                    : _createCommentVNode("", true),
                                _cache[56] || (_cache[56] = _createTextVNode(" Générer ", -1))
                            ], 8, _hoisted_178))
                            : _createCommentVNode("", true)
                    ])
                ])
            ])
        ], 6),
        (_ctx.showCouponModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_180))
            : _createCommentVNode("", true)
    ], 64));
}
